import { useIsVerified } from "src/components/email-verification";
import {
  MainCard,
  MainCardTitle,
  MainCardContent,
} from "src/components/main-card-type.tsx";
import { useEffect, useState } from "react";

import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  sanitizeBrlValue,
  saveCalculatorData,
} from "src/utils/functions";
import { Button } from "src/components/ui/button";
import { calcularINSS, calcularIRRF } from "../utils/deci-teceroFunctions";
import { DecimoResponse } from "../decimo-terceiro";
export const DecimoTerceiroInputCard = ({
  setResults,
}: {
  setResults: (value: DecimoResponse | null) => void;
}) => {
  const [message, setMessage] = useState<string>("");

  const [salariobruto, setSalariobruto] = useState("");
  const [mesestrabalhados, setMesestrabalhados] = useState("");
  const [dependentes, setDependentes] = useState("");
  const [select, setSelect] = useState("unica");
  const calculatorKey = "decimo-terceiro";

  function clear() {
    setSalariobruto("");
    setMesestrabalhados("");
    setDependentes("");
    setSelect("unica");
    setMessage("");
    setResults(null);
  }

  function handleSave() {
    saveCalculatorData(calculatorKey, {
      salariobruto,
      mesestrabalhados,
      dependentes,
      select,
    });
  }
  const isVerified = useIsVerified();

  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setSalariobruto((savedData.salariobruto as string) || "");
    setMesestrabalhados((savedData.mesestrabalhados as string) || "");
    setDependentes((savedData.dependentes as string) || "unica");
  }, []);

  function funcaoDeCalculo() {
    if (!salariobruto) {
      setMessage("Por favor adicione um valor ao Salario Bruto.");
      setResults(null);
      return;
    }
    if (!mesestrabalhados) {
      setMessage(
        "Por favor adicione um valor a quantidade de meses trabalhados",
      );
      setResults(null);
      return;
    }
    if (!dependentes) {
      setMessage("Por favor adicione algo ao Número de Dependentes");
      setResults(null);
      return;
    }
    const ValorBruto = Number.parseFloat(
      salariobruto.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );
    const ValorMeses = Number.parseFloat(
      mesestrabalhados.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );
    const ValorDependente = Number.parseFloat(
      dependentes.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );
    setMessage("");

    let valorFinal: number = 0;
    let proventos: number = 0;
    let porcentagemINSS: number = 0;
    let porcentagemIRRF: number = 0;
    let descontoINSS: number = 0;
    let descontoIRRF: number = 0;

    switch (select) {
      case "unica":
        const valor1 = (ValorBruto / 12) * ValorMeses;
        proventos = Math.round(valor1 * 100) / 100;
        const inss = calcularINSS(valor1);
        descontoINSS = inss.valor;
        porcentagemINSS = inss.aliquotaEfetiva;
        const irrf = calcularIRRF(ValorBruto, inss.valor, ValorDependente);
        porcentagemIRRF = irrf.aliquota;
        descontoIRRF = irrf.valor;
        const final = valor1 - inss.valor - irrf.valor;
        valorFinal = Math.round(final * 100) / 100;
        break;

      case "primeira":
        valorFinal = (ValorBruto * ValorMeses) / 12 / 2;
        proventos = valorFinal;
        valorFinal = Math.round(valorFinal * 100) / 100;
        break;

      case "segunda":
        const value1 = (ValorBruto / 12) * ValorMeses;
        const value2 = value1 / 2;
        proventos = Math.round(value2 * 100) / 100;
        const inss2 = calcularINSS(value1);
        descontoINSS = inss2.valor;
        const irrf2 = calcularIRRF(ValorBruto, inss2.valor, ValorDependente);
        porcentagemINSS = inss2.aliquotaEfetiva;
        porcentagemIRRF = irrf2.aliquota;
        descontoIRRF = irrf2.valor;

        const segundaparcela = value1 - inss2.valor - irrf2.valor - value2;
        valorFinal = Math.round(segundaparcela * 100) / 100; /// Faz com que fique mais aproximado EX: 819.18999999 = 819,19
        break;
    }

    const resultado = {
      ValorBruto: ValorBruto,
      ValorMeses: ValorMeses,
      ValorDependentes: ValorDependente,
      valorfinal: valorFinal,
      porcentagemINSS: porcentagemINSS,
      descontoINSS: descontoINSS,
      porcentagemIRRF: porcentagemIRRF,
      descontoIRRF: descontoIRRF,
      proventos: proventos,
    };
    setResults(resultado);
  }
  return (
    <MainCard>
      <MainCardTitle>Calculadora de Decimo Terceiro</MainCardTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(funcaoDeCalculo);
        }}
      >
        <MainCardContent>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Salario Bruto
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="00,00"
                type="text"
                value={salariobruto}
                onChange={(event) => setSalariobruto(sanitizeBrlValue(event))}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="dependentes-id"
            >
              Numero de Dependentes * (Se houver)
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="dependentes-id"
                placeholder="0"
                type="number"
                value={dependentes}
                onChange={(event) => setDependentes(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Números de meses trabalhados *
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                placeholder="0"
                type="number"
                value={mesestrabalhados}
                onChange={(event) => setMesestrabalhados(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="parcela-id"
            >
              Parcela
            </label>
            <div className="flex border">
              <select
                name=""
                value={select}
                id="parcela-id"
                onChange={(event) => setSelect(event.target.value)}
                className="flex-1 p-2 min-w-[100px]"
              >
                <option value="unica">Única</option>
                <option value="primeira">Primeira</option>
                <option value="segunda">Segunda</option>
              </select>
            </div>
          </div>
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>

          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Button onClick={clear} type="button" variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>

      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};
